var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-header"},[_c('div',{staticClass:"title"},[_c('i'),_vm._v("\n        "+_vm._s(_vm.sectionName)+"\n    ")]),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }